import { ComponentType, IMultiRadioButton } from '@common/types/element';
import React, { FC, Fragment } from 'react';
import {
  ActivityIndicator,
  FlatList,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import { TouchableRipple, useTheme } from 'react-native-paper';
import createStyles from './style';
import useRadioBox, { useRadioBoxProps } from './hook';
import RadioButton from '@common/components/RadioButton';

const RadioBox: FC<IMultiRadioButton> = (attributes) => {
  const {
    list,
    handleChangeValue,
    hasLoadMore,
    isLoading,
    isSelected,
    clearSelection,
    hasSelection,
    onLoadMore,
  }: useRadioBoxProps = useRadioBox(attributes);

  const theme = useTheme();
  const styles = createStyles(attributes);

  const enhancedAttributes = {
    ...attributes,
    ...theme,
    activeColor: theme.colors.primary,
    inactiveColor: theme.colors.background,
  };

  const { showClearButton = false, allowDeselect = false } = attributes;

  if (list.length <= 0) return <Fragment />;
  return (
    <View style={[styles.container, { width: attributes.width }]}>
      {/* Header with clear button */}
      {showClearButton && hasSelection && (
        <View style={styles.headerContainer}>
          <TouchableOpacity onPress={clearSelection} style={styles.clearButton}>
            <Text style={styles.clearButtonText}>Clear Selection</Text>
          </TouchableOpacity>
        </View>
      )}

      <FlatList
        data={list}
        renderItem={({ item }) => {
          const isItemSelected = isSelected(item.value);
          const radioButtonId = `${attributes.id}_${item.value}`;
          return (
            <TouchableRipple
              key={item.value}
              onPress={() => handleChangeValue(item.value)}
              style={styles.radioItem}
            >
              <View pointerEvents="none">
                <View style={styles.radioContent}>
                  <RadioButton
                    {...enhancedAttributes}
                    dependencies={{
                      valueFormInputs: {
                        [radioButtonId]: isItemSelected,
                      },
                    }}
                    id={radioButtonId}
                    type={ComponentType.radio}
                    inactiveIcon={''}
                  />
                  <Text
                    numberOfLines={attributes.numberOfLines || 0}
                    style={[
                      styles.radioText,
                      isItemSelected && styles.radioTextSelected,
                    ]}
                  >
                    {item.custom || item.label}
                  </Text>
                </View>
              </View>
            </TouchableRipple>
          );
        }}
      />
      {/* Load More Button */}
      {!isLoading && hasLoadMore && (
        <View style={styles.loadMoreContainer}>
          <TouchableOpacity onPress={onLoadMore}>
            <Text>More</Text>
          </TouchableOpacity>
        </View>
      )}
      {/* Load More Indicator */}
      {isLoading && (
        <View style={styles.loadMoreContainer}>
          <ActivityIndicator color={theme.colors.primary} />
        </View>
      )}
    </View>
  );
};

export default RadioBox;
